
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22.143,
  height: 25.868,
  viewBox: "0 0 22.143 25.868"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".doc_8aeab33aa5046a1a__cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "doc_8aeab33aa5046a1a__Group_486",
  "data-name": "Group 486",
  transform: "translate(-4.35 -2.661)"
}, /*#__PURE__*/React.createElement("path", {
  id: "doc_8aeab33aa5046a1a__Path_227",
  "data-name": "Path 227",
  className: "doc_8aeab33aa5046a1a__cls-1",
  d: "M22.833 4.017c2.28-.209 3.01.624 3.01 1.393V26.3a1.443 1.443 0 0 1-1.489 1.393H6.489A1.443 1.443 0 0 1 5 26.3V5.41c0-.769.761-1.494 3.083-1.393",
  transform: "translate(0 .185)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "doc_8aeab33aa5046a1a__Rectangle_1645",
  "data-name": "Rectangle 1645",
  className: "doc_8aeab33aa5046a1a__cls-1",
  width: 7.02,
  height: 3.51,
  rx: 1,
  transform: "translate(12.026 3.311)"
}), /*#__PURE__*/React.createElement("path", {
  id: "doc_8aeab33aa5046a1a__Line_13",
  "data-name": "Line 13",
  className: "doc_8aeab33aa5046a1a__cls-1",
  transform: "translate(12.026 13.84)",
  d: "M0 0h7.02"
}), /*#__PURE__*/React.createElement("path", {
  id: "doc_8aeab33aa5046a1a__Line_14",
  "data-name": "Line 14",
  className: "doc_8aeab33aa5046a1a__cls-1",
  transform: "translate(12.026 19.105)",
  d: "M0 0h7.02"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22.143\" height=\"25.868\" viewBox=\"0 0 22.143 25.868\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}\r\n        </style>\r\n    </defs>\r\n    <g id=\"Group_486\" data-name=\"Group 486\" transform=\"translate(-4.35 -2.661)\">\r\n        <path id=\"Path_227\" data-name=\"Path 227\" class=\"cls-1\" d=\"M22.833 4.017c2.28-.209 3.01.624 3.01 1.393V26.3a1.443 1.443 0 0 1-1.489 1.393H6.489A1.443 1.443 0 0 1 5 26.3V5.41c0-.769.761-1.494 3.083-1.393\" transform=\"translate(0 .185)\"/>\r\n        <rect id=\"Rectangle_1645\" data-name=\"Rectangle 1645\" class=\"cls-1\" width=\"7.02\" height=\"3.51\" rx=\"1\" transform=\"translate(12.026 3.311)\"/>\r\n        <path id=\"Line_13\" data-name=\"Line 13\" class=\"cls-1\" transform=\"translate(12.026 13.84)\" d=\"M0 0h7.02\"/>\r\n        <path id=\"Line_14\" data-name=\"Line 14\" class=\"cls-1\" transform=\"translate(12.026 19.105)\" d=\"M0 0h7.02\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/doc.8aeab33aa5046a1a847f3f4fc0203e6d.svg"),
        {
          React: SvgDoc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      